import { LIMUDIM_PROGRAMS } from '../../engine/providers/learningProvider';

/**
 * Hebrew category labels for grouping learning programs.
 */
export const CATEGORY_LABELS = {
  gemara:  'גמרא',
  halacha: 'הלכה',
  tanakh:  'תנ"ך',
  mishna:  'משנה',
  mussar:  'מוסר',
};

/** Display order for categories */
const CATEGORY_ORDER = ['gemara', 'mishna', 'halacha', 'tanakh', 'mussar'];

/**
 * Convert a program key to its settings flag name.
 * 'dafYomi' → 'showDafYomi', 'yerushalmi-vilna' → 'showYerushalmiVilna'
 */
export function toShowKey(key) {
  const camel = key.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
  return 'show' + camel.charAt(0).toUpperCase() + camel.slice(1);
}

/**
 * Build display items from limudim data, filtered by settings.
 *
 * @param {object} limudimData  — payload.limudim from engine
 * @param {object} settings     — show flags from widget props
 * @returns {{ items: Array, groups: Array<{ category, label, items }> }}
 */
export function buildLimudimItems(limudimData, settings) {
  if (!limudimData) return { items: [], groups: [] };

  const progMap = {};
  for (const p of LIMUDIM_PROGRAMS) progMap[p.key] = p;

  const items = [];
  for (const prog of LIMUDIM_PROGRAMS) {
    const showKey = toShowKey(prog.key);
    if (settings[showKey] === false) continue;
    const data = limudimData[prog.key];
    if (!data) continue;

    items.push({
      key: prog.key,
      labelHe: prog.he,
      labelEn: prog.en,
      valueHe: data.name,
      valueEn: data.nameEn,
      url: data.url,
      category: prog.category,
    });
  }

  // Group by category in display order
  const groups = [];
  for (const cat of CATEGORY_ORDER) {
    const catItems = items.filter((it) => it.category === cat);
    if (catItems.length > 0) {
      groups.push({ category: cat, label: CATEGORY_LABELS[cat], items: catItems });
    }
  }

  return { items, groups };
}
